export default __webpack_public_path__ + "static/TROPICO_RAIN_DROPS-1db9025ae117412c799bd4f55098cbe2.png";